module.exports = __webpack_public_path__ + "static/media/masai.c495ce8b.png";